import React from "react";
import { Helmet } from "react-helmet";
import android from "../assets/android.jpg";
import Contactfooter from "./contactfooter";
import ContactComponent from "./ContactComponent";
import image1 from "../assets/carousel/image1.webp";
import image2 from "../assets/carousel/image2.webp";
import image3 from "../assets/carousel/image3.webp";
import image4 from "../assets/carousel/image4.webp";
import amazon from "../assets/amazon-web-service.png";
import azure from "../assets/azure.png";
import flutter from "../assets/services/flutter.png";
import reactNative from "../assets/services/reactNative.png";
import kotlin from "../assets/services/kotlin.jpg";
import ios from "../assets/services/ios.jpg";
import google from "../assets/google-cloud.png";

const imageData = [
  {
    src: image1,
    text: "We provide top-notch web development services tailored to your business needs.",
  },
  {
    src: image2,
    text: "Our e-commerce solutions help businesses establish a strong online presence.",
  },
  {
    src: image3,
    text: "Experience stunning web designs that enhance user engagement and experience.",
  },
  {
    src: image4,
    text: "Responsive and mobile-friendly designs to ensure accessibility on all devices.",
  },
];

const Android = () => {
  return (
    <>
      <Helmet>
        <title>Android Development | theKrisoft</title>
        <meta
          name="description"
          content="Krisoft provides top-notch Android development services, creating innovative and user-friendly mobile applications."
        />
        <meta
          name="keywords"
          content="Android development, mobile apps, Krisoft, app development, Android solutions"
        />
      </Helmet>

      {/* Background Image Section with Right-Side Contact Form */}
      <div
        className="bg-cover bg-center relative flex items-center justify-center md:justify-end"
        style={{ backgroundImage: `url(${android})`, height: "80vh" }}
      >
        <div className="w-full max-w-xs bg-[rgba(255,255,255,0.8)] p-4 rounded-lg shadow-lg mx-auto md:mx-0 md:mr-16 md:max-w-sm">
          <ContactComponent />
        </div>
      </div>

      {/* Content Section */}

      {/* information content */}
      {/* first content */}
      <div className="mx-auto">
        {/* Section 1: Mobile App Development */}
        <div className="bg-gray-200 p-5">
          <p className="text-4xl text-center">Mobile App Development</p>
          <hr className="bg-orange-700 h-1 w-40 mx-auto my-2" />
          <div className="container pt-5 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/developing-mobile-application-abstract-concept-illustration_335657-3814.jpg"
                alt="Mobile App Development"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Mobile App Development
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>Custom mobile app development for iOS and Android.</li>
                <li>Using React Native, Flutter, and native technologies.</li>
                <li>Optimized UI/UX for a seamless user experience.</li>
                <li>
                  Integration of APIs, third-party services, and cloud
                  solutions.
                </li>
                <li>Real-time data synchronization and push notifications.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Section 2: Cross-Platform Development */}
        <div className="bg-gray-300 p-5">
          <div className="container pt-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Cross-Platform Development
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>Develop once, deploy on both iOS and Android.</li>
                <li>
                  Flutter and React Native for fast and efficient development.
                </li>
                <li>Cost-effective solutions with a native-like feel.</li>
                <li>Seamless performance across various screen sizes.</li>
                <li>Optimized animations for an engaging user experience.</li>
              </ul>
            </div>
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/cross-platform-software-development-abstract-concept_335657-3701.jpg"
                alt="Cross-Platform Development"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
          </div>
        </div>

        {/* Section 3: Secure & Scalable Apps */}
        <div className="bg-gray-200 p-5">
          <div className="container pt-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/mobile-security-concept-illustration_114360-8261.jpg"
                alt="Secure and Scalable Apps"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Secure & Scalable Apps
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>
                  Advanced security measures, including authentication and
                  encryption.
                </li>
                <li>
                  Scalable solutions for growing businesses and high traffic.
                </li>
                <li>
                  Integration with cloud services like AWS, Firebase, and Azure.
                </li>
                <li>Payment gateway integration for seamless transactions.</li>
                <li>
                  Performance optimization to ensure a smooth user experience.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* what we used */}
      <div className=" bg-[#FAEBCC] p-4">
        <div className="mt-9 mb-11 md:mt-16">
          <h3 className="text-center text-3xl text-red-800 font-bold mb-6">
            <span className="font-dancing pr-4 text-4xl ">Technologies</span>
            iOS/Android Development
          </h3>
          <hr className="bg-red-800 mt-6 h-1 w-36 mx-auto mb-14" />
          <div className="flex flex-wrap gap-6 mt-10 justify-center">
            {[
              { src: reactNative, name: "React Native" },
              { src: flutter, name: "Flutter" },
              { src: kotlin, name: "Kotlin" },
              { src: ios, name: "Swift (iOS)" },
            ].map((tech, index) => (
              <div key={index} className="flex flex-col items-center">
                <img
                  src={tech.src}
                  alt={tech.name}
                  className="shadow-md w-28 p-2 bg-slate-100 h-24 hover:shadow-xl transition duration-300 rounded-lg bg-transparent border-gray-400 border"
                />
                <p className="mt-2 text-sm font-medium text-gray-700">
                  {tech.name}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-9 mb-11 md:mt-16">
          <h1 className="text-center text-4xl text-red-800 font-bold">
            <span className="font-dancing pr-4">Cloud</span>Technologies
          </h1>
          <hr className="bg-red-800 mt-6 h-1 w-36 mx-auto" />
          <div className="flex flex-wrap gap-4 mt-10 justify-center">
            <img src={google} alt="google" className="sm:w-32 md:w-48" />
            <img src={azure} alt="Azure" className="sm:w-32 md:w-48" />
            <img src={amazon} alt="amazon" className="sm:w-24 md:w-48" />
          </div>
        </div>
      </div>

      <div className="text-center px-6 py-10">
        <h1 className="text-4xl font-bold">
          Benefits of Website Development with The Krisoft
        </h1>
        <p className="mt-6 text-lg">
          We offer comprehensive web design services in Mumbai and beyond,
          working closely with clients to ensure their website aligns with
          business goals.
        </p>
      </div>

      <div className="w-4/5 mx-auto py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {imageData.map((item, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            <img
              src={item.src}
              alt="Web Development Service"
              className="w-40 h-auto rounded-lg mb-4 shadow-md"
            />
            <p className="text-sm text-gray-600">{item.text}</p>
          </div>
        ))}
      </div>
      <Contactfooter />
      <style>
        {`
          @keyframes moveUpDown {
            0% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
            100% { transform: translateY(0); }
          }
          .animate-moveUpDown {
            animation: moveUpDown 2s ease-in-out infinite;
          }
        `}
      </style>
    </>
  );
};

export default Android;
